module.exports = __webpack_public_path__ + "img/2-iconomis-tramites-selected.f1c13a42.svg";